import React from 'react'
import { getContributorsApi, getPutContributorApi, getNextofferingNoApi, getPostContributorApi, getDeleteContributorApi } from '../../services/apiService'
import { showApiError, showApiSuccess } from '../utilities'
import ContributorsTable from './ContributorsTable'
import FormContributor from './ContributorDetails'
import ContributorsFilter from './filter'
import queryString from 'query-string'
import { Row, Col } from 'antd';
//import { withRouter } from 'react-router'


class Contributors extends React.Component {
  constructor(props) {
    super(props)
    const qstrings = queryString.parse(props.location.search)
    this.state = {}
    this.state.dataSource = []
    this.state.contributor = {}
    this.state.loaded = false
    let selectedRow = qstrings.sel || 0
    this.state.selectedRow = parseInt(selectedRow)
    this.currentFilter = qstrings.filter || ""
    let currentPage = qstrings.page || 1

    let pageSize = qstrings.size || 10
    this.queryString = this.props.location.search
    this.handleSelectRow = this.handleSelectRow.bind(this)
    this.handlePageJump = this.handlePageJump.bind(this)
    this.handleFilter = this.handleFilter.bind(this)
    this.loadData = this.loadData.bind(this)
    this.pager = { current: parseInt(currentPage), pageSize: parseInt(pageSize), position: "bottom", onChange: this.handlePageJump, total: 0 }
  }

  componentDidMount() {
    this.loadData(this.queryString, this.state.selectedRow)
  }

  handleDeleteContributor = (id) => {
    //console.log("delete contributor: " + id)
    getDeleteContributorApi(id)
      .then(json => {
        if (typeof json === "string") {
          throw new Error(json)
        } else {
          //console.log('id: ' + id)
          let deletedName = json.displayName || "unknown contributor!"
          let msg = deletedName + " is deleted successfully"
          showApiSuccess(msg)
          let selectedRow = -1
          let updatedData = this.state.dataSource.filter(item => {
            return item.id !== id
          })
          let data = {}
          if (updatedData.length > 0) {
            selectedRow = 0
            data = updatedData[selectedRow]
          }
          this.setState({ dataSource: updatedData, contributor: data, selectedRow: selectedRow })
        }
      })
      .catch(error => {
        showApiError(error)
      })
  }
  

  handlePostNewContributor = (newMemebr) => {
    if (newMemebr.hasOwnProperty("id")) {
      delete newMemebr.id
    }
    getPostContributorApi(newMemebr)
      .then(json => {
        if (typeof json === "string") {
          throw new Error(json)
        } else {
          //console.log(JSON.stringify(json))
          this.setState({ contributor: json})

        }
      })
      .catch(error => {
        showApiError(error)
      })
  }

  loadData(qString, sel) {
    getContributorsApi(qString)
      .then(json => {
        if (typeof json === 'string') {
          throw new Error(json)
        } else {
          let contributor = {}
          let contributors = json.contributors
          //console.log(`${contributors.count}`)
          let count = json.count || 0
          //console.log("number of contributors: " + count)
          this.pager.total = count
          if (contributors.length > 0) {
            let selectedRow = sel || 0
            contributor = contributors[selectedRow]
          }
          this.setState({
            dataSource: contributors, loaded: true, contributor, selectedRow: sel
          })
        }
      })
      .catch(error => {
        showApiError(error)
      })
  }

  handlePageJump = (page, pageSize) => {
    //console.log("which page? " + page)
    //console.log("pageSize?", pageSize)
    let qString = "?filter=" + this.currentFilter + "&page=" + page + "&size=" + pageSize
    this.pager.current = page
    this.loadData(qString, 0)
    let locationSate = { filter: this.currentFilter, page: page }
    window.history.replaceState(locationSate, "members", "members" + qString)
  }

  handleFilter = (e) => {
    e.preventDefault();
    let search = e.target.elements[0].value
    this.currentFilter = search
    this.pager.current = 1

    //if (search) {
      let qString = "?filter=" + search
      this.loadData(qString, 0)
      let locationSate = { filter: this.currentFilter }
      window.history.replaceState(locationSate, "members", "members" + qString)
    //}
  }


  handleAddNew = () => {

    getNextofferingNoApi()
      .then(json => {
        //console.log("json typeof" + typeof json)
        if (typeof json === 'string') {
          //console.log("json content: " + json )
          throw new Error(json)
        } else {
          let nextOfferingNo = json.nextOfferingNo
          //console.log("json: " + json)
          //console.log("nextOfferingNo: " + nextOfferingNo)
          let contributor = {
            "lastName": "",
            "firstName": "",
            "displayName": "",
            "address": "",
            "suburb": "",
            "city": "",
            "postcode": null,
            "country": null,
            "phone": null,
            "fax": null,
            "email": null,
            "organisationId": window.sessionStorage.getItem("OrganisationId"),
            "id": -1,
            "offeringNo": nextOfferingNo,
            "requireReceipt": true,
            "notes": null
          }
          this.setState({ contributor, selectedRow: -1 })
        }
      })


  }

  handleSelectRow = (id, e) => {

    //console.log('nodeName: ' + e.target.nodeName)
    if(e.target.nodeName === 'svg' || e.target.nodeName === 'path') 
      return

    let qString = queryString.parse(window.location.search)
    let currentFilter = qString.filter || ""
    let currentPage = qString.page || 1
    let pageSize = qString.size || 10
    let contributor = this.state.dataSource.find((c) => c.id === id)
    let rowIndex = this.state.dataSource.findIndex((c) => c.id === id)
    qString = `?filter=${currentFilter}&page=${currentPage}&size=${pageSize}&sel=${rowIndex}`
    this.setState({ contributor, selectedRow: rowIndex })
    let locationSate = { filter: this.currentFilter }
    window.history.replaceState(locationSate, "members", "members" + qString)

  }

  saveContributor = (data) => {
    getPutContributorApi(data.id, data)
      .then((data) => {
        let index = this.state.dataSource.findIndex((c) => c.id === data.id)
        let updatedData = [...this.state.dataSource.slice(0, index), data, ...this.state.dataSource.slice(index + 1)]
        this.setState({ dataSource: updatedData, contributor: data, selectedRow: index })
      })
      .catch(error => {
        showApiError(error)
      })
  }


  render() {

    if (!this.state.loaded) {
      return null
    }

    function ContributorDetails(props) {
      if (props.contributor && props.contributor.hasOwnProperty("offeringNo")) {
        return <FormContributor saveChanges={props.saveChanges} contributor={props.contributor}
          deleteContributor={props.deleteContributor}
          saveNew={props.saveNew} />
      }
      else {
        return null
      }

    }

    return (
      <div className="content">
        <h2>{this.props.title}</h2>
        <Row>
          <Col sm={24} md={ 12} style={{ paddingRight: 5 }}>
            <ContributorsFilter
              filter={this.currentFilter} addNew={this.handleAddNew} sumbitFilter={this.handleFilter} />
            <ContributorsTable pager={this.pager}
              contributors={this.state.dataSource} selectedRow={this.state.selectedRow} rowClick={this.handleSelectRow} />
          </Col>
          <Col sm={24} md={ 12} >
            <ContributorDetails contributor={this.state.contributor}
              deleteContributor={this.handleDeleteContributor}
              saveChanges={this.saveContributor}
              saveNew={this.handlePostNewContributor} />
          </Col>
        </Row>
      </div>
    )
  }

}

//const WithRouterContributors = withRouter(Contributors)
export default Contributors;
